import React, { Component } from 'react'

class XofY extends Component {

  getStyle = () => {
    return(
      {
        color: (this.props.x > this.props.y)? '#ef3e43' : '#ffffff',
        fontFamily: 'Avenir',
        fontSize: '18px',
        marginTop: '8px'
      }
    )
  }

  render() {
    return (
      <div>
        <h3 style={this.getStyle()}>{this.props.x} of {this.props.y} Selections Made</h3>
      </div>
    )
  }
}

export default XofY
